import React, { Component } from 'react';

import ReactTable from 'react-table';

import { numberOfRows } from 'helpers/ReactTableSize';
import { toDate, toFriendlyDateString } from 'helpers/Formatter';
import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import constants from 'helpers/constants';
import { localize } from 'react-localize-redux';

class ReferralsTable extends Component {
  render() {
    const tableSize = numberOfRows(this.props.referrals, 'property');

    const columns = [
      {
        header: 'Property',
        headerClassName: 'headerColumn',
        accessor: 'property',
        getProps: () => ({ style: { overflow: 'initial' } }),
        width: 100,
      },
      {
        header: 'Referee',
        headerClassName: 'headerColumn',
        accessor: 'referee.name',
      },
      {
        header: 'Referred to',
        headerClassName: 'headerColumn',
        accessor: 'unit_name',
        getProps: () => ({ style: { overflow: 'initial' } }),
      },
      {
        header: 'Date Referred',
        headerClassName: 'headerColumn',
        accessor: 'date_applied',
        render: row => toFriendlyDateString(toDate(row.value)),
      },
      {
        header: 'Referred By',
        headerClassName: 'headerColumn',
        accessor: 'referrer.name',
      },
      {
        header: 'Status',
        headerClassName: 'headerColumn',
        accessor: 'status',
        render: row => this.renderStatus(row.value),
      },
      {
        header: 'Action',
        headerClassName: 'headerColumn',
        accessor: 'status',
        render: this.renderReviewButton,
      },
    ];

    return (
      <div>
        <ReactTable
          collapseOnSortingChange={false}
          collapseOnPageChange={false}
          collapseOnDataChange={false}
          data={this.props.referrals}
          columns={columns}
          showFilters={false}
          showPagination={false}
          showPageSizeOptions={false}
          pageSize={tableSize}
          noDataText="No Referrals"
          pivotBy={['property']}
        />

        <div style={{ height: '100px' }} />
      </div>
    );
  }

  renderStatus = value => {
    let statusColor = '';
    if (value === constants.referrals.APPLYING) {
      statusColor = colors.YELLOW;
    } else if (value === constants.referrals.CONVERTED || value === constants.referrals.COMPLETED) {
      statusColor = colors.GREEN;
    } else if (value === constants.referrals.UNSUCCESFUL) {
      statusColor = AccentColor();
    } else if (value === constants.referrals.IN_CONTACT) {
      statusColor = colors.GRAY;
    } else {
      return;
    }

    return (
      <span>
        <span style={{ color: statusColor, transition: 'all .3s ease' }}>&#x25cf;</span>
        <span style={{ textTransform: 'capitalize' }}>
          {this.props.translate(`referrals.status.${value}`)}
        </span>
      </span>
    );
  };

  renderReviewButton = row => {
    if (!row || !row.value) return '';

    const { COMPLETED, UNSUCCESFUL, IN_CONTACT } = constants.referrals;
    if (row.value === COMPLETED || row.value === UNSUCCESFUL) return '';

    let actionButtonVerbage = 'Review and Close';
    if (row.value === IN_CONTACT) {
      actionButtonVerbage = 'Review';
    }
    return (
      <button
        type="button"
        className="link-button"
        style={{ fontSize: '14px' }}
        onClick={() => this.props.toggleDialog(row.row)}
      >
        {actionButtonVerbage}
      </button>
    );
  };
}

export default localize()(ReferralsTable);
